exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".basic-card-page {\n  background-color: white;\n}\n.basic-card-page .envoltorio {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: no-wrap;\n  justify-content: flex-start;\n  align-content: center;\n  align-items: center;\n  box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.1);\n}\n.basic-card-page .envoltorio .image {\n  width: 66px;\n  height: 66px;\n  flex-shrink: 0;\n  flex-grow: 0;\n  background-position: center;\n  background-size: cover;\n}\n.basic-card-page .envoltorio .text {\n  margin-left: 15px;\n  flex-shrink: 1;\n  flex-grow: 1;\n}\n.basic-card-page .envoltorio .text .i {\n  font-style: italic;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/catalogo/components/BasicCard.less
// module id = 1346
// module chunks = 0